angular.module('charts')
    .directive('dblStudentProficiency', ['$modal', function($modal) {
        return {
            restrict: 'E',
            scope: {
                dblAst: '=',
                dblGrades: '=',
                dblOnGradeChosen: '&',
                dblProficiencies: '=',
                dblStandardChosen: '&'
            },
            templateUrl: '/resources/charts/directives/student-proficiency/dbl-student-proficiency.directive.html',
            link: function(scope, element) {
                scope.$watch('dblProficiencies', function (newVal) {
                    if (newVal) {
                        scope.domains = newVal.levels[0].domains;
                    }
                });

                scope.$watch('dblGrades', function (newVal) {
                    if (newVal) {
                        scope.grade = _.find(newVal, function (grade) {
                            return grade.isSelected;
                        });
                    }
                });

                scope.onGradeChosen = function (grade) {
                    scope.dblOnGradeChosen({grade: grade});
                    scope.grade = grade;
                };

                scope.openStandardModal = function(domain, standard) {
                    var modal = $modal.open({
                        templateUrl: 'resources/core/partials/domain-standard-modal.html',
                        windowClass: 'domain-standard-modal',
                        controller: 'DomainStandardModalController',
                        backdrop: false,
                        keyboard: true,
                        resolve: {
                          domain: function () {
                            return domain;
                          },
                          grade: function() {
                            var grade = _.find(scope.dblGrades, function (grade) {
                                return grade.isSelected;
                            });

                            return grade;
                          },
                          selectedStandard: function () {
                            return standard;
                          }
                        }
                    });

                    modal.result.then(function (standardDescriptor) {
                        if (standardDescriptor) {
                            scope.dblStandardChosen({standardDescriptor: standardDescriptor});
                        }
                    });
                };
            }
        };
    }]);
